import { render } from "./ProductItemCheckout.vue?vue&type=template&id=4f5ee2f1&scoped=true"
import script from "./ProductItemCheckout.vue?vue&type=script&lang=js"
export * from "./ProductItemCheckout.vue?vue&type=script&lang=js"

import "./ProductItemCheckout.vue?vue&type=style&index=0&id=4f5ee2f1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5ee2f1"]])

export default __exports__